import { createFileRoute, redirect } from "@tanstack/react-router";

// The Calendar view now lives inside the unified planning workspace; preserve
// the farm scope and land on `?view=calendar`.
export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/planning/tasks/calendar",
)({
	// Pure redirect into the workspace — must stay traversable offline.
	staticData: { offline: "ready" },
	beforeLoad: ({ params, search }) => {
		throw redirect({
			to: "/app/org/$orgId/planning",
			params: { orgId: params.orgId },
			search: { farm: (search as { farm?: string }).farm, view: "calendar" },
		});
	},
});
